import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AutoFixHighIcon(props: IconProps) {
    return <Icon {...props} iconKey={"auto_fix_high"}/>
}
